<template>
    <div class="footter">
        <div class="title">
            <img src="../assets/logo-footer.webp" alt="logo" />
        </div>
        <div class="footer-content">
            <!-- <div class="item">
                <div class="text">Pico Finance：1160/2568</div>
            </div> -->
            <div class="item">
                <img src="../assets/footer-icon1.webp" alt="" class="icon">
                <div class="text">268/8 หมู่ที่ 5 ตำบลทุ่งโฮ้ง อำเภอเมืองแพร่ จ.แพร่ 54000</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon2.webp" alt="" class="icon">
                <div class="text">tech@picophraegroup.com</div>
            </div>
            <div class="item">
                <img src="../assets/footer-icon3.webp" alt="" class="icon">
                <div class="text">0545562000348</div>
            </div>
        </div>
        <div class="c">
            © 2026 Hak Cipta milik PICO PHRAE COMPANY LIMITED
        </div>
    </div>
</template>
<script setup>
</script>
<style lang="less" scoped>
.footter {
    width: 100%;
    height: 273px;
    background: #00994F;
    padding: 32px 230px 0;
    box-sizing: border-box;

    .title {
        width: 225px;
        height: 41px;
        margin: 0 auto 46px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .footer-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 143px 59px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);
        margin-bottom: 9px;

        .item {
            display: flex;
            align-items: center;

            .icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }

            .text {
                max-width: 246px;
                font-weight: bold;
                font-size: 12px;
                color: #DCDCDC;
                line-height: 18px;
            }
        }
    }

    .c {
        font-weight: 500;
        font-size: 12px;
        color: #EAEAEA;
        line-height: 24px;
        text-align: center;
    }
}
</style>